import axios from 'axios'

const cache = new Map();

function cachedGet(url) {
    const key = url;

    if (cache.has(key)) {
        return cache.get(key)
    } else {
        const request = axios.get(url);
        cache.set(key, request);
        return request;
    }
}

export const rolesUrl = "/web/rest/auth/roles";

export function get() {
    return cachedGet(rolesUrl)
        .then((result) => result.data);
}
